import { tm } from '../tm'
import { Icon } from '../Icon'
import i18n from './i18n'
import type { CSSProperties } from 'react'
import type { Locales, Project } from '@captaincause/types'

interface LaurierProps {
  className?: string
}

function Laurier({ className = undefined }: LaurierProps) {
  return (
    <svg
      width="12"
      height="24"
      viewBox="0 0 12 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={tm('absolute top-[4px] h-[20px] fill-beige', className)}
    >
      <path d="M11.0814 20.9212C11.427 20.4709 11.2909 19.5075 10.8301 19.1723C10.6835 19.0676 10.5159 19.0153 10.3484 18.9629C8.42149 18.3136 6.77737 16.7952 6.05479 14.8997C5.33222 13.0043 5.55213 10.7423 6.71454 9.06674C7.18578 8.37558 7.80364 7.79962 8.29583 7.11893C9.61531 5.3282 9.99231 2.87772 9.29068 0.762349C9.18596 0.437713 8.99746 0.0711891 8.66235 0.00835632C8.48433 -0.02306 8.29583 0.0397727 8.1178 0.102605C6.56793 0.720461 5.23797 1.95617 4.7353 3.54793C4.23264 5.1397 4.67247 7.03515 5.98149 8.07189C5.82441 8.31275 5.66732 8.55361 5.51024 8.79447C5.14372 7.46451 4.16981 6.31257 2.91316 5.74708C2.70371 5.65283 2.47333 5.57953 2.26388 5.65283C2.12775 5.70519 2.02303 5.82038 1.92878 5.93558C0.923452 7.15034 0.441734 8.84683 0.91298 10.3443C1.38423 11.8419 2.92363 13.0147 4.48397 12.8262C4.51539 13.1509 4.54681 13.4755 4.57822 13.7897C3.39487 13.088 1.99161 12.7739 0.61976 12.8995C0.462679 12.91 0.284653 12.9414 0.169459 13.0566C0.0333216 13.1823 0.0123773 13.3917 0.00190519 13.5907C-0.0399833 15.172 0.609288 16.8161 1.90783 17.7167C3.20638 18.6173 5.14372 18.6068 6.25376 17.4863C6.45273 17.6958 6.64123 17.9157 6.8402 18.1251C5.4893 18.3032 4.20123 18.9734 3.30062 19.9892C3.14354 20.1672 2.98646 20.3871 3.02835 20.628C3.07024 20.8793 3.32157 21.0259 3.54148 21.1411C5.14372 21.9893 6.9554 22.7748 8.72518 22.3559C8.58905 22.7119 8.45291 23.0889 8.54716 23.4554C8.64141 23.822 9.06029 24.1257 9.3954 23.9476C9.7724 23.7487 9.69909 23.1936 9.76192 22.7643C9.87712 21.9893 10.5369 21.5076 11.0395 20.984C11.0605 20.9631 11.0709 20.9421 11.0919 20.9212H11.0814Z" />
    </svg>
  )
}

const CERTIFICATIONS: (keyof typeof i18n.fr)[] = [
  'stable',
  'innovation',
  'ambition',
  'gouvernance',
  'transparency',
  'impact',
]

interface ProjectCCertificationsProps {
  className?: string
  project: Project
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectCCertifications({
  className = '',
  project,
  style = emptyObject,
  locale,
}: ProjectCCertificationsProps) {
  if (!project.is_certified) return null

  const t = i18n[locale]

  return (
    <div className={tm(className)} style={style}>
      <div className="mb-6 flex flex-col gap-4">
        <div className="flex flex-col items-start justify-center font-medium">
          <div className="relative left-4 text-lg">
            <Laurier className="absolute -left-4 top-1" />
            {t.title}
            <Laurier className="absolute -right-4 top-1 [transform:rotateY(180deg)]" />
          </div>
        </div>
        <div className="text-sm text-dark-gray">
          {project.organization.name} {t.is_promo_description}
        </div>
      </div>

      <div className="mb-6 flex flex-col gap-4">
        {CERTIFICATIONS.map((certification, index) => (
          <div
            key={certification}
            className="relative flex items-center justify-start text-sm font-medium"
          >
            <Icon
              icon="check"
              fill="fill-white"
              size="small"
              className="mr-2 rounded-full bg-green"
            />
            {t[certification]}

            {index !== certification.length - 1 ? (
              <div className="absolute -bottom-[15px] left-[7px] h-[14px] w-px bg-medium-gray" />
            ) : null}
          </div>
        ))}
      </div>
      <div className="text-sm text-dark-gray">
        Pour en savoir plus, rendez-vous sur{' '}
        <a
          href="https://dift.com/causes"
          className="inline-block text-sm underline"
          target="_blank"
          rel="noreferrer noopener"
        >
          dift.com/causes
        </a>
      </div>
    </div>
  )
}
